import { PropertyAbstractDTO } from "../DTO/propertyAbstractDTO";
import { PropertyService } from "../services/PropertyService";
import { Address } from "./address";
import { Auction } from "./auction";
import { Client } from "./client";
import { Property } from "./property";
import { PropertyPhase } from "./propertyPhase";
import { SaleType } from "./saleType";
import { State } from "./state";

export class PropertyAbstract{
    public id! : number;
    public propertyId! : string;
    public inventoryId? : number;
    public clientId? : number;
    public taxYear? : number;
    public saleType? : number;
    public propertyType? : number;
    public propertySubType? :number;
    public header? : string;
    public address : Address;
    public judgeId? : number;
    public fileNo? : string;
    public caseNo? : string;
    public clientFileNo? : string;
    public attorneyFileNo? : string;
    public imageReference? : string;
    public views? : number;
    public auctionId? : number;
    public auctionType? : number;
    public isLive : boolean = false;
    public comingSoon : boolean = false;
    public reservePrice? : number;
    public reserveCredit? : number;
    public currentBid? : number;
    public bidCount? : number;
    public scheduleSeqNo? : number;
    public auctionStarting? : Date;
    public auctionEnding? : Date;
    public auctionStatus? : number;
    public saleStatus : number = 0; //see Auction.saleStatus
    public legalAdId? : number;
    public legalAdReference? : string;
    public deleted : boolean = false;
    public isClosed : boolean = false;
    public isCancelled : boolean = false;
    public isPostponed : boolean = false;
    public visibilitySince? : Date;
    public portfolioId?:number;
    public salesManagerId?:string;
    public propertyManagerId?:string;
    public attorneyIds?:string[];
    public assetManagerIds?:string[];
    public propertyPhase!:PropertyPhase;

    //dynamically assigned properties for dashboard display
    public clientObject?: Client;
    public saleTypeObject?:SaleType;
    public portfolioPropertyCount?:number;


    public static dashboardCategoryArray:{id:number,label:string}[] =[{id:10,label:'Active Properties'},{id:20,label:'Active Auctions'}, {id:21,label:'Active Auction Reserve Met'}, {id:22,label:'Active Auction Reserve Not Met'}, {id:30,label:'Pending Sales'}, {id:99,label:'Inactive Properties'}]
    public static statusArray=['Not Live','Live without bids', 'Live with bids', 'Ended without bids', 'Ended', 'Sale Pending', 'Closed', 'Cancelled' ];
    public static statusColorArray=['#C0C0C0','#FFF200', '#00E1FF', '#FF0000', '#00FF0C', '#00B2FF'];
    public static categoryArray=['Live', 'Not Live', 'Ended', 'Closed', 'Deleted'];

    constructor(){
        this.address = new Address();
    }

    public static mapToDTO(param:PropertyAbstract) : PropertyAbstractDTO{
        
        let dto = new PropertyAbstractDTO();
        try
        {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.inventoryId = param.inventoryId;
            dto.clientId = param.clientId;
            dto.taxYear = param.taxYear;
            dto.saleType = param.saleType;
            dto.propertyType = param.propertyType;
            dto.propertySubType = param.propertySubType;
            dto.header = param.header;
            if(param.address) dto.address = Address.mapToDTO(param.address);
            dto.judgeId = param.judgeId;
            dto.fileNo = param.fileNo;
            dto.caseNo = param.caseNo;
            dto.clientFileNo = param.clientFileNo;
            dto.attorneyFileNo = param.attorneyFileNo;
            dto.imageReference = param.imageReference;
            dto.views = param.views;
            dto.auctionId = param.auctionId;
            dto.auctionType = param.auctionType;
            dto.isLive = param.isLive;
            dto.comingSoon = param.comingSoon;
            dto.reservePrice = param.reservePrice;
            dto.reserveCredit = param.reserveCredit;
            dto.currentBid = param.currentBid;
            dto.bidCount = param.bidCount;
            dto.scheduleSeqNo = param.scheduleSeqNo;
            if(param.auctionStarting) dto.auctionStarting = param.auctionStarting.toISOString();
            if(param.auctionEnding) dto.auctionEnding = param.auctionEnding.toISOString();
            dto.auctionStatus = param.auctionStatus;
            dto.saleStatus = param.saleStatus;
            dto.legalAdId = param.legalAdId;
            dto.legalAdReference = param.legalAdReference;
            dto.deleted = param.deleted;
            dto.isClosed = param.isClosed;
            dto.isCancelled = param.isCancelled;
            dto.isPostponed = param.isPostponed;
            if(param.visibilitySince) dto.visibilitySince = param.visibilitySince.toISOString();
            dto.portfolioId=param.portfolioId;
            dto.salesManagerId=param.salesManagerId;
            dto.propertyManagerId=param.propertyManagerId;
            if(param.attorneyIds) dto.attorneyIds = param.attorneyIds.join(',');
            if(param.assetManagerIds) dto.assetManagerIds = param.assetManagerIds.join(',');
            dto.propertyPhaseId=param.propertyPhase?.id;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    public static mapFromDTO(param:PropertyAbstractDTO, propertyService:PropertyService) : PropertyAbstract
    {
        
        let obj = new PropertyAbstract();
        try
        {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.inventoryId = param.inventoryId;
            obj.clientId = param.clientId;
            obj.taxYear = param.taxYear;
            obj.saleType = param.saleType;
            obj.propertyType = param.propertyType;
            obj.propertySubType = param.propertySubType;
            obj.header = param.header;
            if(param.address) obj.address = Address.mapFromDTO(param.address);
            obj.judgeId = param.judgeId;
            obj.fileNo = param.fileNo;
            obj.caseNo = param.caseNo;
            obj.clientFileNo = param.clientFileNo;
            obj.attorneyFileNo = param.attorneyFileNo;
            obj.imageReference = param.imageReference;
            obj.views = param.views;
            obj.auctionId = param.auctionId;
            obj.auctionType = param.auctionType;
            obj.isLive = param.isLive;
            obj.comingSoon = param.comingSoon;
            obj.reservePrice = param.reservePrice;
            obj.reserveCredit = param.reserveCredit
            obj.currentBid = param.currentBid;
            obj.bidCount = param.bidCount;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            if(param.auctionStarting) obj.auctionStarting = new Date(param.auctionStarting);
            if(param.auctionEnding) obj.auctionEnding = new Date(param.auctionEnding);
            obj.auctionStatus = param.auctionStatus;
            obj.saleStatus = param.saleStatus ?? 0;
            obj.legalAdId = param.legalAdId;
            obj.legalAdReference = param.legalAdReference;
            obj.deleted = param.deleted;
            obj.isClosed = param.isClosed;
            obj.isCancelled = param.isCancelled;
            obj.isPostponed = param.isPostponed;
            if(param.visibilitySince) obj.visibilitySince = new Date(param.visibilitySince);
            obj.portfolioId=param.portfolioId;
            obj.salesManagerId=param.salesManagerId;
            obj.propertyManagerId=param.propertyManagerId;
            if(param.attorneyIds) obj.attorneyIds = param.attorneyIds.split(',');
            if(param.assetManagerIds) obj.assetManagerIds = param.assetManagerIds.split(',');
            obj.propertyPhase = propertyService.propertyPhases.find(pp => pp.id == param.propertyPhaseId) || new PropertyPhase(10, 'Pipeline');
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public updateFromProperty(p:Property){
        this.clientId = p.clientId;
        this.taxYear = p.taxYear;
        this.saleType = p.saleType?.id;
        this.propertyType = p.type?.id;
        this.propertySubType = p.subType?.id;
        this.header = p.header;
        if(this.address) Object.assign(this.address,p.address)
        this.judgeId = p.judgeId;
        this.fileNo = p.fileNo;
        this.caseNo = p.caseNo;
        this.clientFileNo = p.clientFileNo;
        this.attorneyFileNo = p.attorneyFileNo;
        if(p.propertyImageArray?.length>0) this.imageReference = p.propertyImageArray[0].reference;
        this.views = p.views;
        this.auctionId = p.auction?.id;
        this.auctionType = p.auction?.auctionType;
        this.isLive = p.auction?.auctionIsLive ?? false;
        this.comingSoon = p.auction?.comingSoon ?? false;
        this.reservePrice = p.auction?.reservePrice;
        this.reserveCredit = p.auction?.currentSchedule?.reserveCredit ?? undefined;
        this.currentBid = p.auction?.highestBidAmount;
        this.bidCount = p.auction?.bids?.length || 0;
        this.scheduleSeqNo = p.auction?.scheduleSeqNo;
        if(p.auction?.auctionStarting) this.auctionStarting = p.auction.auctionStarting;
        if(p.auction?.auctionEnding) this.auctionEnding = p.auction.auctionEnding;
        this.auctionStatus = p.auction?.auctionStatus;
        //public property data doesn't carry the sale status: keep the current value then
        if(p.auction?.saleStatus !== undefined) this.saleStatus = p.auction.saleStatus;
        this.legalAdId = p.auction?.legalAdId;
        this.isClosed = p.auction?.auctionIsClosed ?? false;
        this.isCancelled = p.auction?.auctionIsCancelled ?? false;
        this.isPostponed = p.auction?.auctionIsPostponed ?? false;
        if(p.visibilitySince) this.visibilitySince = p.visibilitySince;
        this.salesManagerId=p.salesManagerId;
        this.propertyManagerId=p.propertyManagerId;
        this.attorneyIds=p.attorneyIds;
        this.assetManagerIds=p.assetManagerIds;
        this.propertyPhase=p.propertyPhase;
    }

    public updateFromPropertyAbstract(p:PropertyAbstract){
        this.inventoryId = p.inventoryId;
        this.clientId = p.clientId;
        this.taxYear = p.taxYear;
        this.saleType = p.saleType;
        this.propertyType = p.propertyType;
        this.propertySubType = p.propertySubType;
        this.header = p.header;
        if(this.address)Object.assign(this.address,p.address);
        this.judgeId = p.judgeId;
        this.fileNo = p.fileNo;
        this.caseNo = p.caseNo;
        this.clientFileNo = p.clientFileNo;
        this.attorneyFileNo = p.attorneyFileNo;
        this.imageReference = p.imageReference;
        this.views = p.views;
        this.auctionId = p.auctionId;
        this.auctionType = p.auctionType;
        this.isLive = p.isLive;
        this.comingSoon = p.comingSoon;
        this.reservePrice = p.reservePrice;
        this.reserveCredit = p.reserveCredit;
        this.currentBid = p.currentBid;
        this.bidCount = p.bidCount;
        this.scheduleSeqNo = p.scheduleSeqNo;
        if(p.auctionStarting) this.auctionStarting = p.auctionStarting;
        if(p.auctionEnding) this.auctionEnding = p.auctionEnding;
        this.auctionStatus = p.auctionStatus;
        this.saleStatus = p.saleStatus;
        this.legalAdId = p.legalAdId;
        this.isClosed = p.isClosed;
        this.isCancelled = p.isCancelled;
        this.isPostponed = p.isPostponed;
        if(p.visibilitySince) this.visibilitySince = p.visibilitySince;
        p.portfolioId=this.portfolioId;
        this.salesManagerId=p.salesManagerId;
        this.propertyManagerId=p.propertyManagerId;
        this.attorneyIds=p.attorneyIds;
        this.assetManagerIds=p.assetManagerIds;
        this.propertyPhase=p.propertyPhase;
    }

    get reserveMet(){
        if(!this.reservePrice || !this.currentBid) return false;
        return this.reservePrice<=this.currentBid;
    }

    get reserveMetWithCredit(){
        if(!this.reservePrice || !this.currentBid || !this.reserveCredit) return false;
        const rc = this.reserveCredit??0;
        return this.reservePrice-rc<=this.currentBid; 
    }

    get auctionEnded():boolean|undefined{
        return this.auctionEnding?(this.auctionEnding.getTime()-(new Date()).getTime()<=0):undefined;
    }

    get auctionTypeHasSchedule():boolean{
        return this.auctionType==1 || this.auctionType==4;
    }

    get auctionIsLiveOrCancelledWithinSchedule(){
        return this.isLive || (this.isCancelled && this.auctionWithinSchedule)
    }

    get auctionWithinSchedule(){
        if(!this.auctionStarting || !this.auctionEnding) return undefined;
        const now = new Date();
        return now >= new Date(this.auctionStarting) && now <= new Date(this.auctionEnding);
    }

    public updateStatus(status:number){
        this.auctionStatus=status;
        if(status===9)this.isCancelled=true;
    }

    public isDashboardCategory(id:number){
        switch(id){
            case 10:
                return this.isActive;
            case 20:
                return this.isLive;
            case 21:
                return this.isLive && this.reserveMet;
            case 22:
                return this.isLive && !this.reserveMet;
            case 30:
                return !this.isLive && this.reserveMet && !this.isClosed;
            case 99:
                return !this.isActive;
            default:
                return false;
        }
    }

    public getDashboardCategoryValue(id:number){
        switch(id){
            case 10:
                return this.reservePrice;
            case 20:
                return this.currentBid;
            case 21:
                return this.currentBid;
            case 22:
                return this.currentBid;
            case 30:
                return this.currentBid;
            case 99:
                return undefined;
            default:
                return undefined;
        }
    }

    get category():string{
        if(this.deleted) return PropertyAbstract.categoryArray[4];
        if(this.isClosed || this.auctionStatus==7) return PropertyAbstract.categoryArray[3];
        if(this.auctionEnded) return PropertyAbstract.categoryArray[2];
        if(this.isLive) return PropertyAbstract.categoryArray[0];
        else return PropertyAbstract.categoryArray[1];
    }

    get hasBids():boolean{
        return this.currentBid? this.currentBid > 0 : false;
    }

    get isActive():boolean{
        return !(this.deleted || this.isCancelled || this.isClosed);
    }

    get status():string|undefined{
        if(this.auctionStatus==3) return PropertyAbstract.statusArray[5];
        if(this.auctionStatus==7) return PropertyAbstract.statusArray[6];
        if(this.auctionEnded && !this.hasBids) return PropertyAbstract.statusArray[3];
        if(this.auctionEnded) return PropertyAbstract.statusArray[4];
        if(this.isLive && this.hasBids) return PropertyAbstract.statusArray[2];
        if(this.isLive && !this.hasBids) return PropertyAbstract.statusArray[1];
        if(!this.isLive) return PropertyAbstract.statusArray[0];
        if(this.isClosed) return PropertyAbstract.statusArray[6];
        if(this.isCancelled) return PropertyAbstract.statusArray[7];
        return undefined;
    }

    get statusDescription():string{
        let str='';
        if(this.auctionType==1) str+='A:';
        if(this.auctionType==2) str+='O:';
        str+=this.status;
        return str;
    }

    //see Auction.showSaleStatus
    get showSaleStatus():boolean{
        return this.auctionType!=1 && this.saleStatus>0 && !this.isClosed && !this.isCancelled;
    }

    get saleStatusLabel(){
        return Auction.saleStatusOptions.find(o=>o.id===this.saleStatus)?.name;
    }

    get dashboardMarkerColor(){
        if(this.isLive) return '#00D000';
        else return 'transparent';
    }

    get displayBidCount(){
        if(this.bidCount){
            if(this.bidCount==1) return '1 Bid';
            else return this.bidCount+' Bids';
        }
        else return '0 Bids';
    }
}